<div class="fleet-selector">
  <div class="form-group">
    <p></p>
    <label for="fleetSelect" class="form-label">Select a Fleet:</label>
    <div class="input-group">
      <div class="dropdown" style="width: 250px;">
        <button class="btn btn-outline-primary dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                type="button"
                id="selectFleetDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                [disabled]="loading || flattenedFleets.length === 0">
          <span>{{ selectedFleet?.id || 'Select a fleet' }}</span>
          <div *ngIf="loading" class="spinner-border spinner-border-sm ms-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
        <ul class="dropdown-menu" style="width: 250px;" aria-labelledby="fleetDropdown">
          <li *ngFor="let fleet of flattenedFleets">
            <a class="dropdown-item cursor-pointer" (click)="selectFleet(fleet)" id="select_fleet_{{ fleet.id }}">
              <span *ngIf="fleet.level > 0" [style.margin-left.px]="fleet.level * 12">&nbsp;</span>
              {{ fleet.id }}
            </a>
          </li>
          <li *ngIf="flattenedFleets.length === 0 && !loading">
            <span class="dropdown-item text-muted">No fleets available</span>
          </li>
        </ul>
      </div>
<!--      <button class="btn btn-outline-secondary" type="button" (click)="loadFleets()" title="Refresh fleets">-->
<!--        <i class="bi bi-arrow-clockwise">Refresh</i>-->
<!--      </button>-->
    </div>
    <div *ngIf="error" class="alert alert-danger mt-2">{{ error }}</div>
  </div>
</div>
